import { useState,useEffect, useContext } from 'react';
import '../styles/stepFour.css'
import AppContext from '../context/formContext';

const StepFour = () => {
    const {setForm}  = useContext(AppContext)
    const [plan, setPlan] = useState();
    const [planRange, setPlanRange] = useState();
    const [price, setPrice] = useState();
    const [addOns, setAddOns] = useState(null);
    const [addOnsPrice,setAddOnsPrice] = useState(0)


    const getPlanValues = () => {
        const planObj = JSON.parse(localStorage.getItem('plan'));
        setPlan(planObj.plan);
        setPrice(+(planObj.price));
        setPlanRange(planObj.range);
    }

    const getAddOnsValues = () => {
        const addOnsList = JSON.parse(localStorage.getItem('addOns'));
        if (addOnsList.length !== 0) {
            setAddOns(addOnsList)
        }
    }

    const getAddOnsTotal = () => {
        const addOnsTotal = JSON.parse(localStorage.getItem('addOnsTotal'));
        setAddOnsPrice(+(addOnsTotal))
    }

    const handleConfirm = () => {
        localStorage.removeItem('addOnsTotal');
        localStorage.removeItem('addOns');
        localStorage.removeItem('plan')

        setForm(5)
    }


    useEffect(() => {
        getAddOnsValues()
        getPlanValues()
        getAddOnsTotal()
    },[])
    
    return ( 
         <div className="stepFourCard">
            <section>
                <h1>Finishing up</h1>
                <p>Double-check everything looks OK before confirming.</p>
            </section>

            <div className="final">
                <div className="items">
                    <div className="plan">
                    <div className="details">
                        <h3>{`${plan} (${planRange})`}</h3>
                        <button onClick={()=> setForm(2)}>Change</button>
                    </div>
                    <span className="price">{planRange === 'Monthly' ? `$${price}/mo` : `$${price}/yr`}</span>
                </div>
        <hr></hr>
                {addOns && 
                    <div className="addOns">
                        {
                            addOns.map((addOn) => (
                                <div className="addOn">
                                    <p className="name">{addOn.name}</p>
                                    <span className="price">{planRange === 'Monthly' ? `$${addOn.value}/mo` : `$${addOn.value}/yr`}</span>
                                </div>
                            ))
                        }
                    </div>
                }

                </div>
                <div className="total">
                    <p>Total{` (per ${planRange})`}</p>
                    <span className="totalPrice">{planRange === 'Monthly' ? `$${price + addOnsPrice}/mo` : `$${price + addOnsPrice}/yr`}</span>
                </div>
            </div>

             <button className='goBack' onClick={()=>setForm(3)}>Go Back</button>
            <button className="nextBtn" onClick={()=>handleConfirm()}>Confirm</button>
        </div>
     );
}
 
export default StepFour;